module.exports = __webpack_public_path__ + "img/icon-lipstick.28325374.png";